var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleDummy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 189,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1523",
    filter: "url(#filter0_d_563_3132)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 4,
    y: 4,
    width: 177,
    height: 151,
    rx: 7.42815,
    fill: "white",
    stroke: "#D2DDE9",
    strokeOpacity: 0.5,
    strokeWidth: 0.464259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 895",
    x: 12.4277,
    y: 52.3145,
    width: 41.085,
    height: 5.2673,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 906",
    x: 12.4277,
    y: 62.8496,
    width: 77.9561,
    height: 5.2673,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 910",
    x: 12.4277,
    y: 73.3828,
    width: 77.9561,
    height: 5.2673,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 911",
    x: 12.4277,
    y: 83.918,
    width: 77.9561,
    height: 5.2673,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 903",
    x: 12.4277,
    y: 42.834,
    width: 41.085,
    height: 4.21384,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 905",
    opacity: 0.6,
    x: 12.4277,
    y: 32.2988,
    width: 41.085,
    height: 5.2673,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 900",
    opacity: 0.5,
    x: 44.7852,
    y: 123.242,
    width: 34.3552,
    height: 4.21384,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder",
    opacity: 0.3,
    d: "M37.3224 112.35H12.5151C12.3881 112.35 12.2852 112.717 12.2852 113.171V134.741C12.2852 135.195 12.3881 135.563 12.5151 135.563H37.3224C37.4494 135.563 37.5524 135.195 37.5524 134.741V113.171C37.5524 112.717 37.4494 112.35 37.3224 112.35Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 2",
    d: "M28.9871 120.491C29.5847 120.491 30.0691 120.002 30.0691 119.399C30.0691 118.796 29.5847 118.307 28.9871 118.307C28.3894 118.307 27.905 118.796 27.905 119.399C27.905 120.002 28.3894 120.491 28.9871 120.491Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836",
    d: "M29.051 127.104C29.051 127.104 28.8667 127.104 28.6417 127.104H19.3388C19.1128 127.104 19.0267 126.948 19.1466 126.755L23.6893 119.457C23.8092 119.264 24.0087 119.263 24.1326 119.451L28.1121 125.538",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M25.8238 127.11C25.8238 127.11 25.9203 126.955 26.0412 126.76L28.6627 122.54C28.7827 122.347 28.9841 122.341 29.113 122.529L31.9411 126.638C32.0698 126.825 31.9919 126.982 31.7635 126.989L29.3003 127.066",
    fill: "#F2F6FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder_2",
    opacity: 0.3,
    d: "M132.037 113H107.23C107.103 113 107 113.368 107 113.821V135.392C107 135.845 107.103 136.213 107.23 136.213H132.037C132.164 136.213 132.267 135.845 132.267 135.392V113.821C132.267 113.368 132.164 113 132.037 113Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 2_2",
    d: "M122.647 121.142C123.245 121.142 123.73 120.653 123.73 120.05C123.73 119.446 123.245 118.958 122.647 118.958C122.05 118.958 121.565 119.446 121.565 120.05C121.565 120.653 122.05 121.142 122.647 121.142Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836_2",
    d: "M122.711 127.754C122.711 127.754 122.527 127.754 122.302 127.754H112.999C112.773 127.754 112.687 127.598 112.807 127.405L117.35 120.107C117.47 119.915 117.669 119.914 117.793 120.102L121.772 126.188",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    d: "M119.484 127.76C119.484 127.76 119.581 127.605 119.701 127.41L122.323 123.19C122.443 122.997 122.644 122.992 122.773 123.179L125.601 127.289C125.73 127.476 125.652 127.633 125.424 127.64L122.961 127.716",
    fill: "#F2F6FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1538_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder_3",
    opacity: 0.3,
    d: "M169.436 32H108.564C108.253 32 108 32.902 108 34.0148V86.9446C108 88.0573 108.253 88.9594 108.564 88.9594H169.436C169.747 88.9594 170 88.0573 170 86.9446V34.0148C170 32.902 169.747 32 169.436 32Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 2_3",
    d: "M146.393 51.9763C147.859 51.9763 149.048 50.7766 149.048 49.2967C149.048 47.8169 147.859 46.6172 146.393 46.6172C144.927 46.6172 143.738 47.8169 143.738 49.2967C143.738 50.7766 144.927 51.9763 146.393 51.9763Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836_3",
    d: "M146.551 68.2026C146.551 68.2026 146.099 68.2026 145.547 68.2026H122.72C122.165 68.2026 121.954 67.8195 122.248 67.347L133.395 49.4393C133.689 48.9667 134.178 48.9641 134.482 49.4249L144.247 64.3597",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_3",
    d: "M138.633 68.2168C138.633 68.2168 138.87 67.8355 139.167 67.3583L145.599 57.003C145.894 56.5289 146.388 56.5154 146.704 56.9751L153.644 67.0592C153.959 67.5179 153.768 67.9036 153.208 67.921L147.164 68.1082",
    fill: "#F2F6FB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 907",
    opacity: 0.5,
    x: 135.783,
    y: 122.965,
    width: 34.3552,
    height: 4.21384,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 899",
    opacity: 0.5,
    x: 44.7852,
    y: 115.814,
    width: 34.3552,
    height: 4.21384,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 908",
    opacity: 0.5,
    x: 135.783,
    y: 115.537,
    width: 34.3552,
    height: 4.21384,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 901",
    opacity: 0.5,
    x: 44.7852,
    y: 130.67,
    width: 34.3552,
    height: 4.21384,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 909",
    opacity: 0.5,
    x: 135.783,
    y: 130.393,
    width: 34.3552,
    height: 4.21384,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 901_2",
    d: "M4 11.4281C4 7.32569 7.3257 4 11.4282 4H173.87C177.973 4 181.298 7.3257 181.298 11.4282V20.7133H4V11.4281Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 48",
    cx: 17.6448,
    cy: 12.078,
    rx: 2.50631,
    ry: 2.507,
    fill: "#FF889D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 49",
    cx: 26.556,
    cy: 12.078,
    rx: 2.50631,
    ry: 2.507,
    fill: "#FBE597"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 50",
    cx: 34.9117,
    cy: 12.078,
    rx: 2.50631,
    ry: 2.507,
    fill: "#6EEFBB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_563_3132",
    x: 0.0538092,
    y: 0.0537481,
    width: 214.671,
    height: 188.605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14.8563,
    dy: 14.8563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.28519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.497656 0 0 0 0 0.619531 0 0 0 0 0.8125 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_563_3132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_563_3132",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleDummy);
export default __webpack_public_path__ + "static/media/role_dummy.83c58b82dc59acdb8ce9240f6a2f254d.svg";
export { ForwardRef as ReactComponent };